import { getVerifyCodeFetch, getUserInfoFetch, ssologinFetch, ssologoutFetch, setFrontUrlFetch } from "../../api/api";
import router from "../../router";
import { resetMenu } from "../../config/table_comlun";
import watermark from "@/utils/waterMark";

const state = {
  isAdmin: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo")).roles?.filter((i) => {
        return ["cash_supervisor", "launch_supervisor", "biAdmin"].includes(i);
      }).length > 0
    : false,
  imageUrl: "",
  userInfo: localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {},
  menu: localStorage.getItem("userInfo")
    ? resetMenu(JSON.parse(localStorage.getItem("userInfo")).menu)
    : [],
  permissions: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo")).permissions
    : [],
};

const actions = {
  async getVerifyCode({ commit }) {
    try {
      const data = await getVerifyCodeFetch();
      if (data) {
        commit("setImageUrl", window.URL.createObjectURL(data));
      }
    } catch (e) {
      throw new Error(e.type);
    }
  },
  async getUserInfo({ commit }, { param, cb }) {
    try {
      const data = await getUserInfoFetch(param);
      if (data.code === "0000") {
        commit("setUserInfo", data);

        // let obj = {
        //   expires: 60 * 15,
        //   currentTime: new Date().getTime()
        // }
        // localStorage.setItem('TIME', JSON.stringify(obj));
        localStorage.setItem("userInfo", JSON.stringify(data.activeUserInfo) || {});
        localStorage.setItem("route", data.activeUserInfo.menu[0].menuAdr);
        router.push({ path: data.activeUserInfo.menu[0].menuAdr });
      } else {
        cb({ type: "error", msg: data.msg });
      }
    } catch (e) {
      throw new Error(e.type);
    }
  },
  async ssologin({ commit }, { cb }) {
    if (process.env["NODE_ENV"] === "development" && process.env["VUE_APP_ISJOINT"] === "false") {
      const param = {
        frontUrl: `${process.env.VUE_APP_FRONT_URL}`,
        frontErrUrl: `${process.env.VUE_APP_FRONT_ERRURL}`,
        frontLogoutUrl: `${process.env.VUE_APP_FRONT_LOGOUTURL}`,
      };
      await setFrontUrlFetch(param);
      await ssoLoginAfter(commit, cb); // 前置修改成功
    } else {
      await ssoLoginAfter(commit, cb);
    }
  },
  async ssologout({ commit }, { param, cb }) {
    try {
      const data = await ssologoutFetch(param);

      cb(data);
      commit("TYPE_NULL", null);
    } catch (e) {
      throw new Error(e);
    }
  },
};

const ssoLoginAfter =async (commit,cb) => {
  try {
    const data = await ssologinFetch();
    if (data.code === "0000") {
      commit("setUserInfo", data);

      localStorage.setItem("userInfo", JSON.stringify(data.activeUserInfo) || {});
      const { username } = JSON.parse(localStorage.getItem("userInfo") || "{}");
      if (username) {
        watermark.set(username, document.documentElement);
      }
      if (data.activeUserInfo.menu.length > 0) {
        commit("setMenu", data.activeUserInfo.menu);
        let firstMenu = data.activeUserInfo.menu.find((item) => {
          return item.menuAdr ? true : false;
        });
        //是否有细分维度报表，有的话跳转到细分维度(进阶版)，否则取第一个菜单
        let hassdcMenu = data.activeUserInfo.menu.find((item) => {
          return item.menuAdr === "single_dimension_collect_test.html";
        });
        if (firstMenu || hassdcMenu) {
          if (hassdcMenu) {
            router.push(hassdcMenu.menuAdr);
          } else {
            router.push(firstMenu.menuAdr);
          }
        }
      } else {
        router.push({ path: "nomenu" });
      }
    } else {
      cb({ type: "error", msg: data.msg });
    }
  } catch (e) {
    throw new Error(e.type);
  }
}

const mutations = {
  setImageUrl(state, userimage) {
    state.imageUrl = userimage;
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo.activeUserInfo;
    state.permissions = userInfo.activeUserInfo.permissions;
  },
  setLoaclUserInfo(state, userInfo) {
    state.userInfo = userInfo;
    state.menu = userInfo.menu;
    state.permissions = userInfo.permissions;
  },
  setMenu(state, newMenu) {
    state.menu = newMenu;
  },
};


export default {
  state,
  actions,
  mutations,
};
